import { render, staticRenderFns } from "./AnalyticsScreenColorsReport.vue?vue&type=template&id=3930ac84&scoped=true&"
import script from "./AnalyticsScreenColorsReport.vue?vue&type=script&lang=js&"
export * from "./AnalyticsScreenColorsReport.vue?vue&type=script&lang=js&"
import style0 from "./AnalyticsScreenColorsReport.vue?vue&type=style&index=0&id=3930ac84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3930ac84",
  null
  
)

export default component.exports